import { pki } from "node-forge";

export const extractPublicKeyFromPrivateKey = (pemPrivateKey) => {
    // privateKey
    // pem = "-----PRIVATE KEY ----- [...]";

    const privateKey = pki.privateKeyFromPem(pemPrivateKey);
    const publicKey = pki.setRsaPublicKey(privateKey.n, privateKey.e);

    return pki.publicKeyToPem(publicKey);
};

export const extractPublicKeyFromCertificate = (pemCertificate) => {
    var cert = pki.certificateFromPem(pemCertificate);
    return pki.publicKeyToPem(cert.publicKey);
};
